export default __webpack_public_path__ + "static/media/agent-bg.949e7eb7.png";